module.exports = __webpack_public_path__ + "static/img/Alejandra.8d89b91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Alejandra.jpg
// module id = Gm6I
// module chunks = 5